import React from "react";
import { SwiperSlide } from "swiper/react";
import { SwiperWraperAffiliate } from "./styles";
import { CardEvent } from "./CardEvent";
import { CardEventYoutube } from "./CardEventYoutube";
import { useApp } from "../../contexts";
import { Navigation } from "swiper";
import { useWindowSize } from "../../hook/useWindowSize";

export const SlideEvent = () => {
  const { T, isMobile } = useApp();
  const size = useWindowSize();
  const getSlidePreview = () => {
    let preview = isMobile ? 1.02 : 1;
    if (size.width >= 720 && size.width < 1024) {
      preview = 2;
    }
    return preview;
  };
  return (
    <div className="w-[100%]">
      <SwiperWraperAffiliate
        loop={true}
        modules={[Navigation]}
        slidesPerView={1}
        navigation={!isMobile}
      >
        {/* <SwiperSlide>
          <CardEvent />
        </SwiperSlide> */}
        <SwiperSlide>
          <CardEventYoutube />
        </SwiperSlide>
      </SwiperWraperAffiliate>
    </div>
  );
};
